import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BackOfficeHome } from 'src/app/Services/Api.BackOfficeHome/BackOfficeHome';
import { OpenModal } from 'src/app/OpenModal';
import { RespuestaItem } from '../../../../../../src/app/Models/Shared/Respuesta';
import {ServicesCommon} from '../../../../Services/Api.Common/ServicesCommon';
import { BilleteraService } from '../../../../Services/Api.Billetera/BilleteraService'
import { MantenedorUsuarioListComponent } from '../mantenedor-usuario-list/mantenedor-usuario-list.component';
import { TypeDialog, ButtonsDialog } from "src/app/model-type";

@Component({
  selector: 'app-mantenedor-usuario-edit',
  templateUrl: './mantenedor-usuario-edit.component.html',
  styleUrls: ['./mantenedor-usuario-edit.component.css']
})
export class MantenedorUsuarioEditComponent implements OnInit {

  perfiles: any[] = [];
  sucursales: any[] = [];
  Form: FormGroup;
  Submitted = false;
  Guardar = false;
  Loading = false;

  constructor(private _BilleteraService: BilleteraService,private fb: FormBuilder, public dialogRef: MatDialogRef<MantenedorUsuarioListComponent>,  
    @Inject(MAT_DIALOG_DATA) public data: any,private _Common: ServicesCommon,private OModal: OpenModal) {       
    this.Form = this.fb.group({
      usuarioID: [data.usuarioID],
      perfilID: [data.perfilID],
      comercioID: [data.comercioID],
      sucursalID: [data.sucursalID],
      nombreCompleto: [data.nombreCompleto],
      sucursal: [data.sucursalID],
      perfil: [data.perfilID],
      usuarioLogin: [this.data.usuarioLogin]
    })
  }

  ngOnInit() {
    this.onObtenerSucursales();
    this.onObtenerPerfiles();
  }

  onCancelar() {
    this.dialogRef.close();
  }

  onEdit() {
    this.Submitted = true;
    if (this.Form.valid === false) {
      return false;
    }
    this.Loading = true;    
    this.data = {
      usuarioID: this.data.usuarioID,
      perfilID: this.Form.get('perfil').value,
      comercioID: this.data.comercioID,
      usuarioLogin: this.Form.get('usuarioLogin').value,
      usuarioPassword: this.data.usuarioPassword,
      sucursalID: this.Form.get('sucursal').value,
      nombreCompleto: this.Form.get('nombreCompleto').value,
      activo: true
    };
    this._BilleteraService.actualizarUsuario(this.data).subscribe(res => {
      const artcl: RespuestaItem = res;
      if (artcl.record != null) {
        this.dialogRef.close(true);
      }
      else if (artcl.error != null) {        
        this.OModal.openDialog(
          TypeDialog.warn,
          "Error",
          artcl.error.description,
          ButtonsDialog.ok,
          300
        );
      }
    },
      err => {
        console.error(err);
      }, () => this.Loading = false
    );
  }


  onObtenerSucursales() {
    this._BilleteraService.obtenerSucursales().subscribe(res => {
      const record = (res as any).recordset;      
      if (record != null) 
        this.sucursales = record;      
    },
    err => {
        console.warn(err); 
    });
  }

  onObtenerPerfiles() {
    this._BilleteraService.obtenerPerfiles().subscribe(res => {
      const record = (res as any).recordset;
      if (record != null) 
        this.perfiles = record;      
    },
    err => {
        console.warn(err);
    });
  }

}

